import EndpointsBase from "../EndpointsBase";
import { API_PATH } from "../../utils/Constants";
class WorkstationEndpoints extends EndpointsBase {
  getWorkstationType(workstationId: number) {
    return this._sendRequest({
      method: `workstation/GetWorkstationType/${workstationId}`,
      data: {},
      run: this.server.getData,
    });
  }
  getWorkstationInformation(workstationId: number) {
      return this._sendRequest({
          method: `workstation/getWorkstationInformation/${workstationId}`,
          data: {},
          run: this.server.getData,
      });
  }

   isBetaWorkstation(workstationId: number) {
    return this._sendRequest({
      method: `workstation/IsBetaWorkstation/${workstationId}`,
      data: {},
      run: this.server.getData,
    });
  }

  isPackingAllowedInWorkstation(workstationId: number) {
    return this._sendRequest({
      method: `workstation/IsPackingAllowed/${workstationId}`,
      data: {},
      run: this.server.getData,
    });
  }

  isAutostoreSkuRemovalDisabled(workstationId: number) {
    return this._sendRequest({
      method: `workstation/isAutostoreSkuRemovalDisabled/${workstationId}`,
      data: {},
      run: this.server.getData,
    });
  }

  checkBurnedOrdersMustBePackedFirst(workstationId: number) {
    return this._sendRequest({
      method: `workstation/BurnedOrdersMustBePackedFirst/${workstationId}`,
      data: {},
      run: this.server.getData,
    });
  }

  operatorLog(operatorId: number, workstationId: number, actionId: number, description: string = "") {
    return this._sendRequest({
      method: `workstation/LogSessionEvent`, 
      data: {
        operatorId: operatorId,
        workstationId: workstationId,
        actionId: actionId,      
        description: description,  
        timestamp: new Date().toISOString()
      },
      run: (this.server as any).postData, 
    });
  }

}

export default new WorkstationEndpoints();
